import React from "react";
import { CallState, RewardsAccount } from "redmond";
import { Skeleton } from "@material-ui/lab";

export const SEARCH_EXPERIENCES_BUTTON = "Search activities";

export const SUBTITLE = (
  <>Book tours and activities you’ll love with elevated travel benefits.</>
);

export const EARN_MESSAGE = (
  { earn, rewardsBalance, productDisplayName }: RewardsAccount,
  showAccountName: boolean = true,
  useStrongTags: boolean = true
) => {
  const { experiencesMultiplier } = earn;

  const earnSymbol = rewardsBalance.currency === "Cash" ? "%" : "X";
  const earnMultiplier = experiencesMultiplier;
  const { currencyDescription } = rewardsBalance;
  const currency = currencyDescription ?? rewardsBalance.currency;

  const experiencesEarnString = `${earnMultiplier}${earnSymbol} ${
    rewardsBalance.currency === "Cash" ? "cash back" : currencyDescription
  }  on activities`;
  const funnelEarnText = (() => experiencesEarnString)();

  const earnText = useStrongTags ? (
    <strong>{funnelEarnText}</strong>
  ) : (
    funnelEarnText
  );
  const accountSuffix = showAccountName
    ? ` with your ${productDisplayName} account.`
    : "";

  if (!!experiencesMultiplier && !!currency) {
    return (
      <span className="font-regular">
        Earn {earnText}
        {accountSuffix}
      </span>
    );
  }

  return <span className="font-regular">Introducing activities</span>;
};

export const getEarnMessageToDisplay = (
  fetchRewardsAccountsCallState: CallState,
  largestValueAccount?: RewardsAccount,
  showAccountName: boolean = true,
  useStrongTags: boolean = true
) => {
  if (
    (fetchRewardsAccountsCallState === CallState.Success ||
      fetchRewardsAccountsCallState === CallState.Failed) &&
    largestValueAccount
  ) {
    return EARN_MESSAGE(largestValueAccount, showAccountName, useStrongTags);
  }

  return <Skeleton className="title-loading" />;
};

export const INFO_MODAL_STORAGE_KEY = "experiences_info_modal_seen";

export const INFO_MODAL_CTA_TEXT = "How do activities work?";
